import React from 'react';
import PropTypes from 'prop-types';
import { bemGenerator } from '@prisjakt/ui-base';

import './sparkline.scss';

const styles = bemGenerator('pj-ui-campaign-item-spark-line', ['path']);

const SparkLine = ({
  values,
  width,
  height,
  solidBackground,
  disableAnimation,
}) => {
  const count = values.length;
  const step = Math.floor(width / (count - 1));
  const min = Math.min(...values);
  const max = Math.min(200, Math.max(...values));
  const scale = (0.7 * height) / Math.max(1, max - min);
  const flipYAndOffset = 0.8 * height;
  let lastY = null;

  function updateLineString(string, prefix, x, point) {
    const y = flipYAndOffset - (Math.min(max, point) - min) * scale;
    return `${string}${prefix}${x} ${y} `;
  }

  return (
    <span className={styles.block.withModifier({ solidBackground })}>
      <svg width={width} height={height}>
        <path
          className={styles.path.withModifier({ animated: !disableAnimation })}
          fill="none"
          strokeMiterlimit="0"
          d={values.reduce((string, point, i) => {
            const prefix = !/^M/.test(string) ? 'M' : 'L';
            let result = string;

            const x = i * step;
            if (point === null) {
              if (lastY !== null) {
                result = updateLineString(string, prefix, x, lastY);
              }
            } else {
              result = updateLineString(string, prefix, x, point);
            }
            lastY = point || lastY;

            return result;
          }, '')}
        />
      </svg>
    </span>
  );
};

const { number, arrayOf, bool } = PropTypes;

SparkLine.propTypes = {
  height: number,
  width: number,
  values: arrayOf(number).isRequired,
  solidBackground: bool,
  disableAnimation: bool,
};

SparkLine.defaultProps = {
  height: 40,
  width: 40,
  solidBackground: false,
  disableAnimation: false,
};

export default SparkLine;
